import React from 'react';
import {
  compose,
  setDisplayName,
  withProps,
  onlyUpdateForKeys,
} from 'recompose';
import reactCSS from 'reactcss';
import * as r from 'ramda';
import { nuller } from '../../../crosscutting/capra';
import { smallprint } from '@ux/type-size';
import { getStyles } from '@ux/style-utils';
import { gu2px } from '@ux/theme-utils';

const stylesheet = ({
  theme,
}) => {
  const {
    spacing,
    typography,
  } = theme;

  return {
    default: {
      root: {
        ...smallprint(typography),
        marginTop: gu2px(1, spacing),
      },
      asterisk: {
        float: 'left',
        paddingRight: gu2px(0.5, spacing),
      },
      messages: {
        overflow: 'hidden',
        textAlign: 'left',
      },
      message: {
        paddingRight: gu2px(0.5, spacing),
        display: 'inline',
      },
    },
  };
};

const stylesheetToStyles = r.unary(reactCSS);

const hasMessages = r.pipe(
  r.prop('messages'),
  r.length,
  r.gt(r.__, 0),
);

const mapIndexed = r.addIndex(r.map);

export const PureDomainLegal = r.ifElse(
  hasMessages,
  ({
    messages,
    styles,
  }) => (
    <div style={styles.root}>
      <span style={styles.asterisk}>
        {'* '}
      </span>
      <div style={styles.messages}>
        {mapIndexed((text, i) => (
          <span
            key={i}
            style={styles.message}
          >
            {text}
          </span>
        ), messages)}
      </div>
    </div>
  ),
  nuller,
);


export const enhance = compose(
  setDisplayName('DomainLegal'),
  onlyUpdateForKeys([
    'messages',
  ]),
  withProps((ownerProps) => ({
    styles: getStyles(stylesheet, stylesheetToStyles, ownerProps),
  })),
);

export default enhance(PureDomainLegal);
